var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Warehouse_data;
class Warehouse {
    constructor(data) {
        _Warehouse_data.set(this, void 0);
        __classPrivateFieldSet(this, _Warehouse_data, data, "f");
    }
    get id() {
        return __classPrivateFieldGet(this, _Warehouse_data, "f").id;
    }
    get name() {
        return __classPrivateFieldGet(this, _Warehouse_data, "f").name;
    }
    get airport() {
        return __classPrivateFieldGet(this, _Warehouse_data, "f").airport;
    }
    get number() {
        return __classPrivateFieldGet(this, _Warehouse_data, "f").number;
    }
    get fullName() {
        return this.name;
    }
}
_Warehouse_data = new WeakMap();
export default Warehouse;
;
